import React, { useState, useRef, useEffect, memo, useContext } from "react";
import { Formik, Form, Field } from "formik";
import { useParams, useNavigate, Link } from "react-router-dom";
import { TagsInput } from "react-tag-input-component";
import * as Yup from "yup";
import Select from "react-select";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import { IoMdAddCircle } from "react-icons/io";
import { Modal } from "react-bootstrap";
import axios from "axios";
import config from "../../../../config/config";
import { uploadAWS } from "../../../../common/AWSHelper";
import { AppContext } from "../../../../context/AppContext";
import {
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  ERROR_EXISTS,
  ALREADY_EXIST,
  AWS_IMAGE_FOLDER_CATEGORIES,
  CUSTOM_SELECT_DROPDOWN_STYLE,
} from "../../../../common/Constant";
import Loader from "../../../../components/Loader/Loader";
import FileInput from "../../../../components/FormControls/FileInput";
import { toastError, toastSuccess, toastWarn } from "../../../../common/Toast";
import AttributesTableRows from "./ItemAttibutetableRow";
import ItemVariactionTableRows from "./ItemVariactionRows";
import { checkUserPermission } from "../../../../common/UserPermission";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const ItemInfo = (props) => {
  const buttonRef = React.useRef(null);
  const navigate = useNavigate();
  const selectRef = useRef(null);
  const token = localStorage.getItem("Token");
  const loginUserId = localStorage.getItem("ID");
  const paramObject = useParams();
  const {ItemIds} = useContext(AppContext)
  useEffect(() => {
    ItemIds(paramObject?.id ? paramObject.id : 0)
  },[paramObject])
  // const [setChangeImagename] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedParentCategory, setselectedParentCategory] = useState(0);
  const [selectedCategory, setselectedCategory] = useState(0);
  const [ImageUrl, setImageUrl] = useState("");
  const [selectedImage, setSelectedImage] = useState("");
  const [data, setData] = useState([]);
  const [SecondCategories, setSecondCategories] = useState([]);
  const [locationsData, setLocationsData] = useState([]); //store loaction from api response
  const [manufacturedropdwonData, setManufactureDropdwon] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [suppliers, setsuppliers] = useState([]);
  const [category, setCategory] = useState([{ ID: 0, CategoryId: "" }]);
  const [supplier, setSupplier] = useState([{ ID: 0, SupplierId: "" }]);
  const [show, setShow] = useState(false); //Show the Categories model
  const [showAddBrand, setShowAddBrand] = useState(false);
  const [Attributemodel, setAttributemodel] = useState(false); // Show The Attribute Model
  const [Modifiers, setModifiers] = useState([]);
  const [check, setCheck] = useState([]);
  const [quantity, setQuantity] = useState([]);
  const [quickbookid, setQuickbookId] = useState(0);
  const [itemquickbookid, setItemQuickbookId] = useState(0);
  const [itemProductID, setItemProductID] = useState("");

  // tags-
  const [selectedtags, setSelectedtags] = useState("");
  const [iddata, setiddata] = useState();
  const [formValuesfortagmodel, setFormValuesforTagmodel] = useState({
    ID: 0,
    Tags: "",
  });
  const [showtag, setShowTag] = useState(false);
  const [tagsdropdwonData, setTagsdropdwonData] = useState([]);

  // manufacturers-
  const [showManufacture, setShowManufacture] = useState(false);
  const [formValuesformenufacturemodel, setFormValuesforMenufacturemodel] =
    useState({ ID: 0, Manufacture: "" });
  const [selectmanufacturedropdwonData, setselectmanufacturedropdwonData] =
    useState(0);

  const [Variationlist, setVariationlist] = useState([]);
  const [x, setX] = useState();
  const [WeightUnit, setWeightUnit] = useState(0);
  const [itemattributes, setItemAttributes] = useState("");
  const [options, setOptions] = useState([]);
  const [Attributedrop, setAttributedrop] = useState(false);
  const [SelectedAttributedrop, setSelectedAttributedrop] = useState([]);
  const [SelectedAttributelabledrop, setSelectedAttributelabeldrop] = useState(
    []
  );
  const [SelectedAttributeIddrop, setSelectedAttributeIddrop] = useState([]);
  const [SelectedAttributelablecommadrop, setSelectedAttributelablecommadrop] =
    useState([]);
  const [ItemFieldshow, setItemFieldshow] = useState(false);
  const [itemattribute, setItemAttribute] = useState([]); // Items Attributes Values Rows
  const [Itemvariations, setItemvariations] = useState([]); // Itemvariation Values Rows
  const [SubmitEvent, setSubmitEvent] = useState(0);

  const [globalAttribute, setGlobalAttribute] = useState();
  const [attributeName, setAttributeName] = useState();
  const [attributeValue, setAttributeValue] = useState();
  const [item, setItem] = useState([{ ID: 0, ItemNumbers: "" }]);
  const [selectMultipleSupplierFlag, setSelectMultipleSupplierFlag] =
    useState(false);

  const [accountquickbookid, setAccountQuickbookId] = useState(0);
  const [expensequickbookid, setExpenseQuickbookId] = useState(0);
  const [incomequickbookid, setIncomeQuickbookId] = useState(0);
  const [expenseaccountid, setExpenseAccountId] = useState(0);
  const [incomeaccountid, setIncomeAccountId] = useState(0);
  const [accountid, setAccountId] = useState(0);
  const [quickbookvariationdeleteid, setQuickbookVariationDeleteID] = useState(
    []
  );
  const [costprice, setCostPrice] = useState(0);
  const [unitprice, setUnitPrice] = useState(0);
  const [itemNameForVariation, setItemNameForVariation] = useState("");

  console.log(Itemvariations, "Itemvariations")
  // For Error
  const [nameError, setNameError] = useState("");
  const [error, setError] = useState({
    brandError: "",
    tagError: "",
    manufactureError: "",
  });
  const [attributeError, setAttributeError] = useState("");
  const [formValues, setFormValues] = useState({
    ItemName: "",
    BarcodeName: "",
    UpcName: "",
    ProductId: "",
    Tags: "",
    Description: "",
    LongDescription: "",
    ImPOP: "",
    Weight: parseFloat(0.0).toFixed(2),
    WeightUnit: "",
    DimensionsLength: parseFloat(0.0).toFixed(2),
    DimensionsWidth: parseFloat(0.0).toFixed(2),
    DimensionsHeight: parseFloat(0.0).toFixed(2),
    DefaultQuantity: parseFloat(0.0).toFixed(2),
  });


  console.log(item, "itemfroitem")
  console.log(formValues, "formvalue")

  const [newVariation, setNewVariation] = useState([]);

  // // handleChangeforitems-
  // const handleChangeforitems = (index, event) => {
  //   let name, values;
  //   name = event.target.name;
  //   values = event.target.value;

  //   const cardInput = [...item];
  //   cardInput[index][name] = values;

  //   let ItemArray  = cardInput;
  //   console.log(values,ItemArray?.some(tag => tag?.ItemNumbers.toLowerCase() === itemProductID.toLowerCase()), "checkvalidation" )
  //   if (ItemArray?.some(tag => tag?.ItemNumbers.toLowerCase() == itemProductID.toLowerCase())) {
  //     console.log(`Product ID ${itemProductID} exists in tagsID 1`);
  //     toastWarn(`${itemProductID} Item Number is not same as Product Id`);
  //     cardInput[index][name] =  ""
  //   }


  //   setItem(cardInput);
  // };

  // const handleChangeforitems = (index, event) => {
  //   let name, values;
  //   name = event.target.name;
  //   values = event.target.value;
    
  //   const oldvalue = item[index]?.ItemNumbers
  //   const cardInput = [...item];
  //   cardInput[index][name] = values;


  //   console.log(values, "strp1 0147")
  //   if (values.trim() !== '') {
  //     console.log(values, "strp2 0147")
  //     if (values.toLowerCase() == itemProductID.toLowerCase()) {
  //       console.log(values.toLowerCase(),itemProductID.toLowerCase(),  values.toLowerCase() == itemProductID.toLowerCase(), "strp3 0147")
  //       console.log(`Product ID ${itemProductID} exists in tagsID 1`);
  //       toastWarn(`${itemProductID} Item Number is not same as Product Id`);
  //       cardInput[index][name] = values.slice(0, -1);
  //     }
  //   }else{
  //     cardInput[index][name] = '';
  //   }
  
  //   setItem(cardInput);
  // };

  const handleChangeforitems = (index, event) => {
    const { name, value } = event.target;
    const oldvalue = item[index]?.ItemNumbers;
    const cardInput = [...item];
    cardInput[index][name] = value.trim() === '' ? '' : value;
  
    if (value.trim() !== '' && value.toLowerCase() === itemProductID.toLowerCase()) {
      toastWarn(`${itemProductID} Item Number is not same as Product Id`);
      cardInput[index][name] = value.slice(0, -1);
    }
  
    setItem(cardInput);
  };

  // for close and open tags, manufacturers-
  const handeltagmodelClose = () => setShowTag(false);
  const handeltagmodelShow = () => setShowTag(true);
  const handleManufactureClose = () => setShowManufacture(false);
  const handleManufactureShow = () => setShowManufacture(true);
  // ---------------------------------------------

  // variation checkbox
  const [variationCheckBox, setVariationCheckBox] = useState(false);
  const [isservice, setisservice] = useState(false);

  let PERMISSION_ADD = "add-brand";

  //Additional Item Numbers Row Delete
  const deleteForAdditionalTableRows = (index) => {
    const rows = [...item];
    rows.splice(index, 1);
    setItem(rows);
  };

  // ADD item-
  const addItem = () => {
    const rowsInput = {
      ID: 0,
      ItemNumbers: "",
    };
    setItem([...item, rowsInput]);
  };

  // item number array-
  let ItemsNumbersArray = item.map((item) => item.ItemNumbers);

  // for App Context-
  const {
    valueStringFunction,
    deleteTableRowsFunction,
    fetchBrandFunction,
    fetchItemVariation,
    autoGenerationFunction,
  } = useContext(AppContext);

  const ActionButtons = (props) => {};
  const handleBack = () => {
    props.previousStep();
    window.scrollTo(0, 0);
  };

  // Create and Update Prime Supplier-
  const [primeSupplier, setPrimeSupplier] = useState({
    label: "",
    value: "",
  });
  const handleChangePrimeSupplier = (e) => {
    setPrimeSupplier({ label: e.label, value: e.value });
    setQuickbookId(e.quickbookid);
  };

  // Crete and Update Brand-
  const [addBrand, setAddBrand] = useState("");
  const handleAddBrand = (eventObject) => {
    eventObject.preventDefault();

    if (addBrand === "") {
      return setError({ ...error, brandError: "Please Fill Brand" });
    }

    if (addBrand !== "") {
      setLoading(true);
      axios
        .post(
          `${config.brandBaseUrl}/brands/upsert`,
          {
            id: 0,
            isactive: 1,
            name: addBrand,
            loginuserid: loginUserId,
          },
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          if (res.data.ResponseCode === "SUCCESS") {
            console.log(res.data, "add brands check")
            toastSuccess(SUCCESS_MESSAGE);
            setShowAddBrand(false);
            fetchBrandFunction(SUCCESS_MESSAGE);
            setLoading(false);
            setError({ ...error, brandError: "" });
            setAddBrand("");
            brandsApiList()
            setSelectedBrand(res.data.ResponseID)
            
            // window.location.reload();
          } else if (
            res.data.ResponseCode === "ERROR" &&
            res.data.ResponseID === -1
          ) {
            toastError(ERROR_EXISTS);
            setShowAddBrand(false);
            setLoading(false);
            setAddBrand("");
          } else {
            toastError(ERROR_MESSAGE);
            setLoading(false);
            setLoading(false);
            setAddBrand("");
          }
        });
    }
  };

  // -----------------------tags----------------------
  let TagsList = [];
  tagsdropdwonData?.map((u, i) => {
    TagsList[i] = { label: u.Name, value: u.ID };
  });

  const handleTagsDropdowns = (seletedId) => {
    // tags dropdown values
    axios
      .get(`${config.tagBaseUrl}/tags/tagsdropdown?tagtype=Portal`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setTagsdropdwonData(res.data.ResponseData);

        return res;
      });
  };

  useEffect(() => {
    axios
      .get(
        `${config.accountingBaseUrl}/chartofaccounts/accountdefaultitemaccount`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )

      .then((res) => {
        // alert(JSON.stringify(res.data))
        const accountdata = res.data?.ResponseData[0];
        const incomedata = res.data?.ResponseData[1];
        const expensedata = res.data?.ResponseData[2];
        setAccountId(isservice === true ? 0 : accountdata?.accountid);
        setIncomeAccountId(
          isservice === true ? 12 : incomedata?.incomaccountid
        );
        setExpenseAccountId(
          isservice === true ? 0 : expensedata?.expenceaccountid
        );
        setIncomeQuickbookId(incomedata?.incomaccountQuickbookid);
        setExpenseQuickbookId(expensedata?.expenceaccountQuickbookIdid);
        setAccountQuickbookId(accountdata?.accountQuickbookid);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const handleSelectedtags = (e) => {
    const selectedTagValues = (Array.isArray(e) ? e.map((x) => x.value) : [])
      .join(",")
      .trim();
    setSelectedtags(selectedTagValues);
  };

  // handleSubmit for tags model
  const handleSubmitformodeltags = async (eventObject) => {
    if (!eventObject.Tags) {
      return setError({ ...error, tagError: "Please Fill Tag" });
    }
    setLoading(true);
    axios
      .post(
        `${config.tagBaseUrl}/tags/upsert`,
        {
          id: 0,
          ecommerecetagid: 1,
          name: eventObject.Tags,
          tagtype: "Portal",
          loginuserid: loginUserId,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(SUCCESS_MESSAGE);
          handleTagsDropdowns();
          setSelectedtags([...selectedtags, res.data.ResponseID]);
          setselectmanufacturedropdwonData(selectmanufacturedropdwonData);
          const clearData = {
            ID: 0,
            Tags: "",
          };
          let fixvalues = formValues;
          setFormValues(fixvalues);
          setFormValuesforTagmodel(clearData);
          setError({ ...error, tagError: "" });
          setShowTag(false);
          setLoading(false);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError(ERROR_EXISTS);
          setFormValuesforTagmodel({
            ID: 0,
            Tags: "",
          });
          setError({ ...error, tagError: "" });
          setLoading(false);
        } else {
          toastError(ERROR_MESSAGE);
          setFormValuesforTagmodel({
            ID: 0,
            Tags: "",
          });
          setError({ ...error, tagError: "" });
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        setShowTag(false);
      });
  };

  // ---------------------manufacturers-------------------
  const handleDropdowns = (selectedIds) => {
    // supplier dropdown
    axios
      .get(`${config.suppliersBaseUrl}/suppliers/dropdownsupplier`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setsuppliers(res.data.ResponseData);
        return res;
      });

    // manufacture dropdon values
    axios
      .get(
        `${config.manufacturerBaseUrl}/manufacturers/manufacturersdropdown`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setManufactureDropdwon(res.data.ResponseData);
        if (selectedIds != undefined) {
          // Binding Category data
          let CategorieList = res.data.ResponseData;
          CategorieList.map((selectedManufacture) => {
            if (selectedManufacture.ID == selectedIds) {
              setselectmanufacturedropdwonData(selectedManufacture.ID);
            }
          });
        }
        // setLoading(false);
        return res;
      });
  };

  useEffect(() => {
    handleDropdowns();
  }, [props]);

  const handleSubmitformodelManufacture = async (eventObject) => {
    if (!eventObject.Manufacture) {
      return setError({
        ...error,
        manufactureError: "Please Fill Manufacturer",
      });
    }

    setLoading(true);
    axios
      .post(
        `${config.manufacturerBaseUrl}/manufacturers/upsert`,
        {
          id: 0,
          isactive: 1,
          name: eventObject.Manufacture,
          loginuserid: loginUserId,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(SUCCESS_MESSAGE);
          const clearData = {
            ID: 0,
            Manufacture: "",
          };
          let fixvalues = formValues;
          setFormValues(fixvalues);
          handleDropdowns();
          setSelectedtags(selectedtags);
          handleDropdowns(res.data.ResponseID);
          setFormValuesforMenufacturemodel(clearData);
          handleManufactureClose();
          setError({ ...error, manufactureError: "" });
          handleDropdowns();
          setselectmanufacturedropdwonData(res.data.ResponseID);
          setLoading(false);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError(ERROR_EXISTS);
          setError({ ...error, manufactureError: "" });
          setFormValuesforMenufacturemodel({
            ID: 0,
            Manufacture: "",
          });
          setLoading(false);
        } else {
          toastError(ERROR_MESSAGE);
          setError({ ...error, manufactureError: "" });
          setFormValuesforMenufacturemodel({
            ID: 0,
            Manufacture: "",
          });
          setLoading(false);
        }
      });
  };

  useEffect(() => {
    axios
      .get(`${config.tagBaseUrl}/tags/tagsdropdown?tagtype=Portal`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setTagsdropdwonData(res.data.ResponseData);
        setLoading(false);
        return res;
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  const handleSubmitForm = () => {
    setSubmitEvent(1);
  };
  const handleNext = () => {
    props.nextStep();
    window.scrollTo(0, 0);
  };

  // let rows;
  const deleteTableRows = async (index) => {
    setLoading(true);
    axios
      .post(
        `${config.itemsBaseUrl}/items/itemattributedelete`,
        {
          id: itemattribute[index].ID,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(SUCCESS_MESSAGE);
          let rows = [...itemattribute];
          rows = rows.filter((obj) => obj.ID === index);
          setItemAttribute(rows);
          deleteTableRowsFunction(rows);
          setLoading(false);
          setAttributedrop(true);
          if (Attributedrop === true) {
            setAttributedrop(true);
          } else {
            setAttributedrop(false);
          }
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError(ERROR_EXISTS);
          setLoading(false);
        } else {
          toastError(ERROR_MESSAGE);
          setLoading(false);
        }
      })
      .catch((err) => {});
  };
  const validationSchema = Yup.object().shape({
    ItemName: Yup.string().required("Name is required"),
  });


  const handelProductChange = (e) => {
    const value = e.target.value.trim();
    if (value && item?.some(tag => tag.ItemNumbers.toLowerCase() === value.toLowerCase())) {
      toastWarn(`${value} Item Number is not same as Product Id`);
    } else {
      setItemProductID(value);
      // setFormValues({ ...formValues, ProductId: value });
    }
  }

  // const handleAttributesValues=()=>{
  //   axios
  //   .get(
  //     `${config.itemsBaseUrl}/items/itemswiseattributeslist?ItemId=${paramObject.id}`,
  //     {
  //       headers: {
  //         "Content-Type": "application/json;charset=UTF-8",
  //         Authorization: token,
  //       },
  //     }
  //   )
  //   .then((res) => {
  //     console.log(Variationlist,"variationlist===>>")
  //     setVariationlist(res.data.ResponseData);
  //   });
  // }

  // console.log(Variationlist,"variationlist====>")

  // const selectStyles = {
  //   control: (provided) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "40px",
  //     position: "relative",
  //   }), // dropdown input css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
  //     position: "absolute",
  //     background: "#f8f8f8",
  //     width: "100%",
  //     zIndex: 99,
  //   }), // dropdown menu css
  // };

  // const selectStyles = {
  //   control: (provided) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "0px",
  //     position: "relative",
  //   }), // dropdown input css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
  //     position: "absolute",
  //     background: "#f8f8f8",
  //     width: "100%",
  //     zIndex: 99,
  //     // border: "solid orange",
  //   }),
  //   valueContainer: () => ({
  //     // padding: "0px 6px !importan",
  //     height: "0px !important",
  //     display: "contents",
  //   }),
  // };

  // HANDLEFOR DROPDOWN CHNAGES BUTTONS FOR ADD ATTRIBUTES
  const handledrop = (e) => {
    if (e.target.value === "NewCustomAttribute") {
      setAttributedrop(true);
    } else {
      const selectedIndex = e.target.selectedIndex;
      const selectedOption = e.target.options[selectedIndex];
      const selectedValues2 = selectedOption.getAttribute("values2"); // for attribiutes commasepredvalue get
      const label = selectedOption.label; // get attribute name
      const Values = selectedOption.value;
      setSelectedAttributedrop(selectedValues2);
      setSelectedAttributeIddrop(Values);
      setSelectedAttributelabeldrop(label);
      setAttributedrop(false);
    }
  };

  const addNewQuantity = () => {
    setQuantity([
      ...quantity,
      {
        QuantityId: 0,
        Quantityname: "",
        Quantityunit: parseFloat(0.0).toFixed(2),
        Quantitysellingprice: parseFloat(0.0).toFixed(2),
        Quantitycostprice: parseFloat(0.0).toFixed(2),
        Quantityitemnumber: "",
        Quantitydefaultforsale: false,
        Quantitydefaultforreceive: false,
      },
    ]);
  };

  const addNewVariaction = () => {
    const rowsInput = {
      ItemVariationId: 0,
      VariationName: itemNameForVariation,
      VariationAttributes: "",
      VariationItemNumber: "",
      VariationID: 0,
      SupplierId: "",
      VariationProductId: "",
      itemvariationquickbookid: 0,
    };
    setItemvariations([...Itemvariations, rowsInput]);
  };

  // variation-
  const [keepAttributesForNewVariation, setKeepAttributesForNewVariation] =
    useState();

  useEffect(() => {
    const output = [];
    const tempMap = {};

    attributeValue?.forEach((item) => {
      const key = `${item.Attributeid}`;
      if (!tempMap[key]) {
        tempMap[key] = {
          Quantity: [],
        };
      }
      tempMap[key].Quantity.push({
        ID: item.ID,
        Name: item.Name,
        Attributeid: item.Attributeid,
        Attributevalueid: item.Attributevalueid,
        VariationQuantity: item.VariationQuantity,
      });
    });

    for (const key in tempMap) {
      output.push(tempMap[key]);
    }

    setKeepAttributesForNewVariation(output);
  }, [attributeValue, autoGenerationFunction]);

  const handleautovariaction = async () => {
    setLoading(true);
    // Convert in to Array Object Of Quantity Values Ids with CommaSeparate
    console.log(
      keepAttributesForNewVariation,
      "keepAttributesForNewVariation===>"
    );
    // return;

    const QuntityIdCommaSeparate = keepAttributesForNewVariation?.map(
      (obj) => ({
        ...obj,
        Quantity: obj.Quantity?.map((qty) => qty.ID).join(","),
      })
    );

    // Convert in to Array Object Of Quantity Values with CommaSeparate
    const QuntityValueCommasepret = keepAttributesForNewVariation.map(
      (obj) => ({
        ...obj,
        Quantity: obj.Quantity.map((qty) => qty.Name).join(","),
      })
    );

    // Separet From Array Object of Quntity Ids
    const CommaSepateIds = QuntityIdCommaSeparate.map((obj) =>
      obj?.Quantity?.split(",").map(Number)
    );
    // Separet From Array Object of Quntity Values
    const CommaSepateValues = QuntityValueCommasepret.map((obj) =>
      obj?.Quantity?.split(",")
    );

    // Make Variation With Ids with Array Object
    const SeparetIds = Object.values(CommaSepateIds).reduce((acc, curr, i) => {
      if (i === 0) {
        return curr.map((x) => x); //[x]
      } else {
        const newAcc = [];
        acc.forEach((item) => {
          curr.forEach((val) => {
            newAcc.push([item, val]?.toString());
          });
        });
        return newAcc;
      }
    }, []);

    // Make Variation With Values with Array Object
    // const SeparetValues = Object.values(CommaSepateValues).reduce(
    //   (acc, curr, i) => {
    //     if (i === 0) {
    //       return curr.map((x) => [x]);
    //     } else {
    //       const newAcc = [];
    //       acc.forEach((item) => {
    //         curr.forEach((val) => {
    //           newAcc.push([item,val]?.toString());
    //         });
    //       });
    //       return newAcc;
    //     }
    //   },
    //   []
    // );


    console.log(CommaSepateIds, "checkcommaseperated")
    console.log(SeparetIds, "checkcommaseperated")
    // console.log(CommaSepateValues, "checkcommaseperated")
    const SeparateValues = Object.values(CommaSepateValues).reduce(
      (acc, curr) =>
        acc.flatMap((item) => curr.map((val) => [item, val].join(" - "))),
      [""]
    );

    const ItemsNames = itemNameForVariation // formValues.ItemName;
    const VariactionNames = SeparateValues.map((val) => `${ItemsNames}${val}`);

    // Final Array Object For Sent
    const FinalResult = [];
    for (let i = 0; i < SeparetIds.length; i++) {
      const variationName = VariactionNames[i];
      const variationValue = SeparetIds[i];

      // const checkObject = Itemvariations?.find(el => String(variationValue)?.includes(el.VariationAttributes)) || {}; 
      // const checkObject = Itemvariations?.find(el => el.VariationAttributes == String(variationValue)) || {}; 


      // console.log(checkObject, "FinalResultvariation")
      //   FinalResult.push({
      //     VariationName: variationName,
      //     VariationValue: String(variationValue),
      //     itemvariationquickbookid: checkObject?.itemvariationquickbookid || 0,
      //     variationquantity: checkObject?.variationquantity || 0, // newVariation?.find((el)=> el?.Name == VariactionNames[i])?.VariationQuantity
      //     VariationProductId: checkObject?.VariationProductId || "",
      //     VariationItemNumber: checkObject?.VariationItemNumber || "",
      //     VariationSupplierId: checkObject?.SupplierId || "",
      //     ItemVariationId: checkObject?.ItemVariationId || 0,
      //     CreatedBy: loginUserId || 0,
      //   });
      // } 
        
    
      FinalResult.push({
          VariationName: variationName,
          VariationValue: String(variationValue),
          itemvariationquickbookid: 0,
          variationquantity: 0, // newVariation?.find((el)=> el?.Name == VariactionNames[i])?.VariationQuantity
          VariationProductId: "",
          VariationItemNumber: "",
          VariationSupplierId: "",
          ItemVariationId: 0,
          CreatedBy: loginUserId || 0,
        });
    } 

    const FilterModel = Itemvariations?.map(el => {return {
      VariationName: el.VariationName,
      VariationValue: el.VariationAttributes,
      itemvariationquickbookid: el?.itemvariationquickbookid || 0,
      variationquantity: el?.variationquantity || 0, // newVariation?.find((el)=> el?.Name == VariactionNames[i])?.VariationQuantity
      VariationProductId: el?.VariationProductId || "",
      VariationItemNumber: el?.VariationItemNumber || "",
      VariationSupplierId: el?.SupplierId || "",
      ItemVariationId: el?.ItemVariationId || 0,
      CreatedBy: loginUserId || 0,
    }})

    

  //   const mergedArray = FinalResult.map(genItem => {
  //     const matchingVarItem = FilterModel.find(varItem => varItem.VariationValue === genItem.VariationValue);
  
  //     // If a match is found in FilterModel, return the FilterModel object, otherwise return the original genItem
  //     return matchingVarItem ? matchingVarItem : genItem;
  //   });
  
  // console.log(mergedArray, "FinalResultvariation");


  const variationMap = new Map();
  // Create a map to store items from both arrays based on VariationValue

    // Add all items from GeneratedArray to the map
    FinalResult.forEach(genItem => {
        variationMap.set(genItem.VariationValue, genItem);
    });

    // Override or add items from variationArray to the map
    FilterModel.forEach(varItem => {
        variationMap.set(varItem.VariationValue, varItem);  // If exists, it will override; if not, it will add.
    });

// Convert the map back to an array of merged items
const mergedArray = Array.from(variationMap.values());

console.log(mergedArray, "FinalResultvariation");

  

    console.log(FinalResult, "FinalResultvariation")
    console.log(FilterModel, "FinalResultvariation")

    // return;
    const jsonobj = {};
    jsonobj.variation = mergedArray //FinalResult;

    let jsonstring = JSON.stringify(jsonobj);

    await axios
      .post(
        `${config.itemsBaseUrl}/items/variationinsert`,
        {
          itemId: paramObject.id,
          ItemName: itemNameForVariation,
          XMLVariation: jsonstring,
          loginuserid: loginUserId,
          quickbookexpenseid: expensequickbookid,
          quickbookincomeid: incomequickbookid,
          quickbookinventoryassestid: accountquickbookid,
          itemquickbookid: itemquickbookid.toString(),
          isservice: isservice === true ? 1 : 0,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          const VariactionName = res.data.ResponseData.VariactionName;
          const ItemIdsparams = paramObject.id;

          // Make the Object For Bind the Values
          const ResultObject = VariactionName?.map((obj) => {
            return {
              ItemVariationId: obj?.ID,
              VariationName: obj?.Name,
              VariationAttributes: obj?.VariationAttributes,
              VariationItemNumber: obj?.VariationItemNumber,
              VariationID: `${ItemIdsparams}-${obj?.ID}`,
              SupplierId: obj?.VariationSupplierId,
              VariationProductId: obj?.VariationProductId,
              itemvariationquickbookid: obj?.itemvariationquickbookid
            };
          });
          setItemvariations(ResultObject);
          toastSuccess(SUCCESS_MESSAGE);
          fetchItemVariation(SUCCESS_MESSAGE);

          axios
            .get(
              `${config.itemsBaseUrl}/items/itemswiseattributeslist?ItemId=${paramObject.id}`,
              {
                headers: {
                  "Content-Type": "application/json;charset=UTF-8",
                  Authorization: token,
                },
              }
            )
            .then((res) => {
              setVariationlist(res.data.ResponseData);
            });
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError("Name" + ALREADY_EXIST);
        } else {
          toastError(ERROR_MESSAGE);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const addCategory = () => {
    const rowsInput = {
      ID: 0,
      CategoryId: "",
    };

    setCategory([...category, rowsInput]);
  };

  const addSupplier = () => {
    const rowsInput = {
      ID: 0,
      SupplierId: "",
    };
    setSupplier([...supplier, rowsInput]);
  };

  var isCheck = (item) =>
    check.includes(item.ID) ? "checked-item" : "not-checked-item";

  let ParentCategoryOption = [];
  const ItemKits = data.map((u, i) => {
    ParentCategoryOption[i] = {
      label: u.Name,
      value: u.ID,
      quickbookid: u.QuickbookId,
    };
  });

  let Catagories = [];
  const ItemCategories = SecondCategories.map((u, i) => {
    Catagories[i] = { label: u.Name, value: u.ID };
  });

  //Supplies comma separated
  let Supplierlist = [];
  const Supplierlists = suppliers.map((u, i) => {
    // Supplierlist[i] = { label: u.FirstName, value: u.ID };
    Supplierlist[i] = {
      label: u.Name,
      value: u.ID,
      quickbookid: u.QuickBookId,
    };
  });

  // dropdown of manufature
  let Manufacturerdropdown = [];

  // handel for Categories
  const handleChangeforDropdon = (index, event) => {
    let name, values;
    name = "CategoryId";
    values = event.value;

    const cardInput = [...category];
    cardInput[index][name] = values;
    setCategory(cardInput);
  };

  const handleChangeforDropdonsuppliers = (index, event) => {
    let name, values;
    name = "SupplierId";
    values = event.value;

    const cardInput = [...supplier];
    cardInput[index][name] = values;
    setSupplier(cardInput);
  };

  const resetSelect = () => {
    document.getElementById("selected").selectedIndex = 0;
  };

  // Handle Change Attributes-
  const handleAttributeChange = (e) => {
    console.log(e,"878");
    
    let name, values;
  
      name = "Quantity";
      values = e.target.value?.toString();
      
    setSelectedAttributelablecommadrop((prevState) => ({
      ...prevState,
      [name]: values,
    }));
  };

  // Post Attributes -
  const handleChangeforattribute = async (e) => {
    e.preventDefault();
    console.log(SelectedAttributelablecommadrop,"878");
    

    if (itemattributes.trim() === "") {
      setNameError("Attribute name is required");
      setAttributeError("");
      return;
    } else if (!SelectedAttributelablecommadrop?.Quantity?.split(",")) {
      setAttributeError("Attribute value is required");
      setNameError("");
      return;
    } else {
      setNameError("");
      setAttributeError("");

      let QuantityValues = SelectedAttributelablecommadrop.Quantity?.toString();
      const AttributeInsertObj = {
        id: 0,
        itemid: paramObject.id,
        attributename: itemattributes,
        attributevalues: QuantityValues,
      };

      setLoading(true);

      try {
        const response = await axios.post(
          `${config.itemsBaseUrl}/items/attributesinsert`,
          AttributeInsertObj,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        );

        if (response.data.ResponseCode === "SUCCESS") {
          resetSelect();
          setAttributedrop(false);
          getDataFunction();
          const newRow = {
            ID: response.data.ResponseData.Attributename[0].ID,
            Name: response.data.ResponseData.Attributename[0].Name,
            Quantity: response.data.ResponseData.Attributevalues,
          };
          toastSuccess(SUCCESS_MESSAGE);
          const updatedItemAttribute = [...itemattribute, newRow];
          setItemAttribute(updatedItemAttribute);
          setItemAttributes("");
          setAttributemodel(false);
          setLoading(false);
          setX(response.data);
          setSelectedAttributelablecommadrop("");
        } else if (
          response.data.ResponseCode === "Sucess" &&
          response.data.ResponseID === -1
        ) {
          toastError("Attribute" + ALREADY_EXIST);
          setItemAttributes("");
          setLoading(false);
        } else {
          toastError(ERROR_MESSAGE);
          setItemAttributes("");
          setLoading(false);
        }
      } catch (error) {
        console.log(error, "Error in attributesinsert");
      }
    }
  };

  // HandleChanges of Quantity Units
  const handleChangeQuantityUnitsRow = (index, event) => {
    let id, name, values;
    if (event.target.type === "checkbox") {
      name = event.target.name;
      if (event.target.checked === true) {
        values = 1;
      } else {
        values = 0;
      }
    } else {
      name = event.target.name;
      values = event.target.value;
    }
    const rowsInput = [...quantity];
    rowsInput[index][name] = values;
    setQuantity(rowsInput);
  };

  const [brands, setBrands] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState();

  // const [mainSupplier, setMainSupplier] = useState();
  // const [selectedSupplier, setSelectedSupplier] = useState();



  const brandsApiList = ()=>{
    axios
    .get(`${config.brandBaseUrl}/brands`, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: token,
      },
    })
    .then((res) => {
      setBrands(res.data.ResponseData);
      setLoading(false);
    })
    .catch((err) => {
      setLoading(false);
    });
  }

  useEffect(() => {
    setLoading(true);
   brandsApiList()
  }, [props, fetchBrandFunction]);



  //Brands Dropdown-
  const Brandsdropdown = [];
  brands.map((u, i) => {
    Brandsdropdown[i] = { label: u.Name, value: u.ID };
  });




  //deleteVatriation
  const deleteTableRowsVariaction = (index, data) => {
    const rows = [...Itemvariations];
    rows.splice(index, 1);
    setQuickbookVariationDeleteID([
      ...quickbookvariationdeleteid,
      data.itemvariationquickbookid,
    ]);
    setItemvariations(rows);
  };

  // console.log(quickbookvariationdeleteid,"quickbookvariationdeleteid==>")

  const [selectSupplierIdFlag, setSelectSupplierIdFlag] = useState(false);
  //handlechange of Variation
  const handleChangeVariation = (index, event, vname) => {
    // console.log("handleChangeVariation name=> ", event.target.name);
    // console.log("handleChangeVariation value=>", event.target.value);
    // console.log("handleChangeVariation variation=>", index, event, vname);
    let id, name, values;
    // if(vname === "variation"){
    //   const payload=y.length-1;
    //   console.log(y[payload],"145 payload==>")

    //   const existingindex=y.findIndex((item)=> item.attributeid==y[payload].attributeid)
    //   console.log(existingindex,"145 existingindex==>")
    //   let attributesvalues;
    //   let data=[...y]

    //   console.log(data, "data 145")
    //   if(existingindex!== -1){
    //     data.splice(existingindex,1)
    //    attributesvalues=data.map((item,index)=>item.value)
    //   }else{
    //     attributesvalues=data.map((item)=>item.value)
    // }

    // console.log(attributesvalues,"145 attributesvalues==>")

    // if (event.target === undefined) {
    //   name = "VariationAttributes";
    //   values = attributesvalues?.toString();
    // } else {
    //   name = event.target.name;
    //   values = event.target.value;
    // }
    //   console.log(name, values,"attributesvalues==>")
    //   // const updateddata= [...Itemvariations]
    //   // updateddata[existingindex]={...updateddata[existingindex],VariationAttributes: attributesvalues}
    //   // console.log(updateddata,"updateddata==>")
    //   // setItemvariations(updateddata)

    if (vname === "VariationAttributes") {
      name = vname;
      values = event;
    } else {
      name = event.target.name;
      values = event.target.value;
    }

    // console.log(name, values, "final");
    const rowsInput = [...Itemvariations];


    console.log(rowsInput[index], "productid check condionron")

    if (vname === "VariationAttributes") {
      const ids = values.split(",");
      const names = Variationlist.filter((item) => ids.includes(`${item.ID}`))
        .map((item) => item.Name)
        .join(" - ");

      // console.log(Variationlist, "789")
      // console.log(values, "789")
      // console.log(ids, "789")
      // console.log(names, "789")

      rowsInput[index][name] = values;
      rowsInput[index]["VariationName"] = `${itemNameForVariation.trim()} - ${names.trim()}`;
    } else  if (vname === "VariationProductId"){

      if (rowsInput[index]?.VariationItemNumber?.split(",")?.some(tag => tag.toLowerCase() === values.toLowerCase())) {
        console.log(`Product ID ${values} exists in tagsID 1`);
        toastWarn(`${values} Item Number is not same as Product Id`);
      }else{
        rowsInput[index][name] = values;
      }

    } else {
      rowsInput[index][name] = values;
    }
    // console.log("handleChangeVariation rowsInput[index][name]", index, name);
    // console.log("handleChangeVariation rowsInput", rowsInput);

    if (name === "SupplierId" && index === 0 && !selectSupplierIdFlag) {
      for (let i = 0; i < rowsInput.length; i++) {
        rowsInput[i][name] = values;
      }
      setSelectSupplierIdFlag(true);
    }
    // console.log("handleChangeVariation 984", name, selectSupplierIdFlag);
    setItemvariations(rowsInput);
  };

  // handlechange For Attirbutes
  const handleChangeAttributesTableRow = (event) => {
    let name, values;
    if (event.target === undefined) {
      name = "AttributesValue";
      values = event?.toString();
    } else {
      name = event.target.name;
      values = event.target.value;
    }
  };

  // deleted Secendory Categories
  const deleteSecondory = (index) => {
    const rows = [...category];
    rows.splice(index, 1);
    setCategory(rows);
  };

  // deleted Suppliers
  const deleteSuppliers = (index) => {
    const rows = [...supplier];
    rows.splice(index, 1);
    setSupplier(rows);
  };

  const updateVariationName = (inputValue) => {
    const updatedVariations = Itemvariations.map((variation) => {
      const [prefix, ...suffix] = variation.VariationName.split('-');

      console.log(prefix, " | ", suffix, "chnagename")
      if(variation.VariationName.includes('-')){
        return {
          ...variation,
          VariationName: `${inputValue.trim()} - ${suffix.join('-').trim()}`,
        };
      }else{
        console.log(itemNameForVariation, " >> ", variation.VariationName.replace(itemNameForVariation, inputValue ))
        return {
          ...variation,
          VariationName: `${variation.VariationName.replace(itemNameForVariation, inputValue )}`,
        };
      }
    });

    console.log(updatedVariations, "updatedVariations")
    setItemvariations(updatedVariations)
  };

  // close and show model pop
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleCloseAddBrand = () => setShowAddBrand(false);
  const handleShowAddBrand = () => setShowAddBrand(true);

  const handeltagsmodelClose = () => setAttributemodel(false);
  const handeltagsmodelShow = () => setAttributemodel(true);

  const handleAttributsAdd = async (e) => {
    // Check this for Attributessssssssss
    const AttributeInsertObj = {
      id: SelectedAttributeIddrop,
      itemid: paramObject.id,
      attributename: SelectedAttributelabledrop,
      attributevalues: "", //SelectedAttributedrop,
    };

    axios
      .post(
        `${config.itemsBaseUrl}/items/attributesinsert`,
        AttributeInsertObj,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          getDataFunction();
          const newRow = {
            ID: res.data.ResponseData.Attributename[0].ID,
            Name: res.data.ResponseData.Attributename[0].Name || "",
            Quantity: res.data.ResponseData.Attributevalues,
          };
          const cardInput = [...itemattribute, newRow];
          setItemAttribute(cardInput);
          setLoading(false);
          setX(res.data);
          resetSelect();
          toastSuccess(SUCCESS_MESSAGE);
        } else if (
          res.data.ResponseCode === "Sucess" &&
          res.data.ResponseID === -1
        ) {
          toastError("Attribute" + ALREADY_EXIST);
          setLoading(false);
        } else {
          toastError(ERROR_MESSAGE);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log(error, "Error is in attributesinsert");
      });
  };

  /* AWS FILE UPLOAD */
  const _handleFileChange = (e) => {
    // console.log("Image selected function 20052024");

    // setChangeImagename(true);

    if (vaidation(e.target.name, e?.currentTarget?.files[0])) {
      uploadFile(e?.currentTarget?.files[0], e.target.name);
    } else {
      console.log("Image extension validation failed");
    }
    // console.log("Image selected failed function 20052024");
  };

  const vaidation = (name, value) => {
    switch (name) {
      case "Imagename":
        if (!value.name.match(/\.(jpg|jpeg|png|gif|mp4)$/)) {
          return false;
        } else {
          return true;
        }
      default: {
        return true;
      }
    }
  };

  const uploadFile = async (file, type) => {
    console.log("image upload function 20052024");
    setLoading(true);
    uploadAWS(file, AWS_IMAGE_FOLDER_CATEGORIES, (data) => {
      if (data) {
        console.log(data, "url of image selected 20052024");
        setImageUrl(data);
        setLoading(false);
      }
    });
  };

  // Model Processs
  // model validations
  const validationSchemaformodel = Yup.object().shape({
    CategoryName: Yup.string().required("Name is required"),
  });

  const [formValuesformodel, setFormValuesformodel] = useState({
    ID: 0,
    CategoryName: "",
    ProductId: "",
    Hidefromgrid: "",
    ParentID: 0,
    Color: "",
    Ecommerce: "",
    Imagename: "",
    CategoryInfopopup: "",
  });
  manufacturedropdwonData.map((u, i) => {
    Manufacturerdropdown[i] = { label: u.Name, value: u.ID };
  });

  const handleDropdownData = (CategorieData) => {
    setLoading(true);
    //for model bind the cetegoires
    axios
      .get(`${config.categoriesBaseUrl}/categories?filtertext=${""}`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setData(res.data.ResponseData);
        setSecondCategories(res.data.ResponseData);
        if (CategorieData != undefined) {
          let CategorieList = res.data.ResponseData;
          CategorieList.map((selectedCategory) => {
            if (selectedCategory.ID == CategorieData) {
              setselectedCategory({
                label: selectedCategory.Name,
                value: selectedCategory.ID,
                quickbookid: selectedCategory.QuickbookId,
              });
            }
          });
        }
      });

    // supplier dropdown
    axios
      .get(`${config.suppliersBaseUrl}/suppliers/dropdownsupplier`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setsuppliers(res.data.ResponseData);
        return res;
      });

    axios
      .get(`${config.modifiersBaseUrl}/modifiers/selectall`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setModifiers(res.data.ResponseData);
      })
      .catch((err) => {
        // setLoading(false);
      });

    // for bind loactions in model
    axios
      .get(`${config.priceRulesBaseUrl}/pricerules/locationdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLocationsData(res.data.ResponseData);
        return res;
      });

    axios
      .get(
        `${config.attributesBaseUrl}/attributes/selectalldropdown?itemid=${paramObject.id}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setOptions(res.data.ResponseData);
        return res;
      });
    setLoading(false);
  };

  // useEffect(()=>{
  // if( newVariation?.length > 0){
  //   setVariationCheckBox(true)
  // }else{
  //   setVariationCheckBox(false)
  // }
  // },[newVariation])

  const handelVariationCheckFun = (checked) => {
    if (checked) {
      setVariationCheckBox(true);
    } else {
      if (Itemvariations?.length === 0) {
        setVariationCheckBox(false);
      } else {
        toastWarn(
          "You cannot uncheck the box due to the existence of item variations."
        );
        setVariationCheckBox(true);
      }

      // setVariationCheckBox(false)
    }
  };
  const handelisserviceCheckFun = (checked) => {
    if (checked) {
      setisservice(true);
    } else {
      setisservice(false);
    }
  };

  //locations comma separated
  let itemOption = [];
  locationsData.map((u, i) => {
    itemOption[i] = { label: u.Name, value: u.Id };
  });

  //handlesubmit for categories
  const handleSubmitformodel = async (eventObject) => {
    setLoading(true);
    axios
      .post(
        `${config.categoriesBaseUrl}/categories/upsert`,
        {
          id: eventObject.ID,
          name: eventObject.CategoryName,
          hidefromgrid: selectedItems?.toString(),
          parentid: selectedParentCategory.value
            ? selectedParentCategory.value
            : 0,
          imagename: ImageUrl,
          color: eventObject.Color,
          categoryinfopopup: "",
          loginuserid: loginUserId,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(SUCCESS_MESSAGE);
          const clearData = {
            ID: 0,
            Name: "",
            Hidefromgrid: false,
            ParentID: 0,
            Color: "",
            Imagename: "",
            CategoryInfopopup: "",
          };
          setFormValuesformodel(clearData);
          handleDropdownData(res.data.ResponseID);
          setImageUrl("");
          setShow(false);
          setLoading(false);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError(ERROR_EXISTS);
          setLoading(false);
        } else {
          toastError(ERROR_MESSAGE);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log(error, "Erro is in Categories Upsert");
      });
  };

  const handleSubmit = async (value) => {
    if (selectedCategory == 0) {
      return toastError("Please Select Category");
    }

    // if(primeSupplier.value==""){
    //   return toastError("Please Select Supplier")
    // }

    let Variationdata = Itemvariations?.filter(function (Itemvariations) {
      return Itemvariations.VariationName != "";
    });

    if (Itemvariations?.some((obj) => obj.VariationAttributes === "")) {
      return toastError("Please Fill All Variations");
    }

    const removeValue = Variationdata?.map(el =>{  
      return {...el, VariationName: el?.VariationName.replace(/'/g, "\\'").toString(),
        itemvariationquickbookid:el.itemvariationquickbookid > 0  ? el.itemvariationquickbookid : 0
      }})

    console.log(removeValue, "removeValue")
    const Variationobject = {};
    Variationobject.itemvariationxml = removeValue // Variationdata;
    let Variationjsonstring = "";
    Variationjsonstring = JSON.stringify(Variationobject);
    let Quantityjsonstring = "";
    if (quantity.length > 0) {
      let data = quantity.filter(function (quantity) {
        return quantity.Name != "";
      });

      const Quantityjsonobj = {};
      Quantityjsonobj.Quantityunitxml = data;
      Quantityjsonstring = JSON.stringify(Quantityjsonobj);
    } else {
      Quantityjsonstring = "";
    }


    let deletedItemQuickbookIds = ""
    if(paramObject.id > 0){
     await axios
      .get(
        `${config.itemsBaseUrl}/items/getdeletedQuickbookid?itemId=${paramObject.id}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          
          const ListofDeletedItemQuickbookIds = res.data.ResponseData?.map(el => el.QuickBookId);
          const ListofCurrentItemQuickbookIds = removeValue?.map(el => el.itemvariationquickbookid);
          console.log(ListofDeletedItemQuickbookIds, "Deletedquickbookids")
          console.log(ListofCurrentItemQuickbookIds, "Deletedquickbookids")
            const combineArray = [...ListofDeletedItemQuickbookIds, ...ListofCurrentItemQuickbookIds] || []
          const uniqueElements = combineArray?.filter(item => combineArray.indexOf(item) === combineArray.lastIndexOf(item));
          deletedItemQuickbookIds = uniqueElements?.join(',')
        }})
        .catch((error) => {
          console.log(error, "Erro is in deleted Item Quickbook id");
        });
    }

    // return;
    let categoryIdArray = category.map((item) => item.CategoryId);
    let supplierIdArray = supplier?.map((item) => item?.SupplierId);
    let Object = {};
    if (paramObject.id === undefined) {
      Object = {
        xmlVariaction: "",
        xmlquantityitems: "",
        id: 0,
        name: value.ItemName,
        itemnumbers: ItemsNumbersArray?.toString(),
        barcodename: value.BarcodeName,
        categoryid: selectedCategory.value || 0,
        loginuserid: loginUserId,
        secondarycategoryIds: categoryIdArray?.toString(),
        modifierIds: "",
        upc: value.UpcName,
        brand: selectedBrand || 0,
        supplierIds: supplierIdArray?.toString(),
        productid: itemProductID,
        description: value.Description,
        longdescription: value.LongDescription,
        infopopup: value.ImPOP,
        weight: value.Weight > 0 ? value.Weight : 0,
        length: value.DimensionsLength > 0 ? value.DimensionsLength : 0,
        width: value.DimensionsWidth > 0 ? value.DimensionsWidth : 0,
        height: value.DimensionsHeight > 0 ? value.DimensionsHeight : 0,
        weightunit: WeightUnit,
        manufacturerid: selectmanufacturedropdwonData || 0,
        tagsids: selectedtags || "",
        supplierid: primeSupplier?.value || 0,
        suppliername: primeSupplier?.label,
        supplierquickbookid: quickbookid,
        categoryquickbookid:
          selectedCategory.quickbookid > 0 ? selectedCategory.quickbookid : 0,
        inventoryassestaccountid: accountid,
        incomeaccountid: incomeaccountid,
        expenseaccountid: expenseaccountid,
        incomeaccountquickbookid: incomequickbookid,
        inventoryassestquickbookid: accountquickbookid,
        expenseaccountquickbookid: expensequickbookid,
        isservice: isservice === true ? 1 : 0,
        deletedItemQuickbookIds : ""
      };
    } else {
      Object = {
        xmlVariaction: Variationjsonstring,
        xmlquantityitems: Quantityjsonstring,
        id: paramObject.id,
        name: value.ItemName,
        itemnumbers: ItemsNumbersArray?.toString(),
        barcodename: value.BarcodeName,
        categoryid: selectedCategory.value || 0,
        loginuserid: loginUserId,
        secondarycategoryIds: categoryIdArray?.toString(),
        supplierIds: supplierIdArray?.toString(),
        modifierIds: check?.toString(),
        upc: value.UpcName,
        brand: selectedBrand || 0,
        productid: value.ProductId,
        description: value.Description,
        longdescription: value.LongDescription,
        infopopup: value.ImPOP,
        weight: value.Weight > 0 ? value.Weight : 0,
        length: value.DimensionsLength > 0 ? value.DimensionsLength : 0,
        width: value.DimensionsWidth > 0 ? value.DimensionsWidth : 0,
        height: value.DimensionsHeight > 0 ? value.DimensionsHeight : 0,
        weightunit: WeightUnit,
        manufacturerid: selectmanufacturedropdwonData || 0,
        tagsids: selectedtags || "",
        supplierid: primeSupplier.value || 0,
        suppliername: primeSupplier?.label,
        supplierquickbookid: quickbookid,
        itemquickbookid: itemquickbookid,
        categoryquickbookid:
          selectedCategory.quickbookid > 0 ? selectedCategory.quickbookid : 0,
        inventoryassestaccountid: accountid,
        incomeaccountid: incomeaccountid,
        expenseaccountid: expenseaccountid,
        incomeaccountquickbookid: incomequickbookid,
        inventoryassestquickbookid: accountquickbookid,
        expenseaccountquickbookid: expensequickbookid,
        quickbookvariationdeleteid: quickbookvariationdeleteid,
        unitprice: unitprice,
        costprice: costprice,
        isservice: isservice === true ? 1 : 0,
        deletedItemQuickbookIds: deletedItemQuickbookIds,
      };
    }

    setLoading(true);
    axios
      .post(`${config.itemsBaseUrl}/items/upsert`, Object, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          setLoading(false);
          toastSuccess(SUCCESS_MESSAGE);
          if (paramObject.id === undefined) {
            const ItemID = res.data.ResponseID;
            navigate(`/manage-Items/${ItemID}`);
            setItemFieldshow(false);
            if (!variationCheckBox) {
              localStorage.setItem(
                "isservicedata",
                isservice === true ? "true" : "false"
              );
              props.nextStep();
              window.scrollTo(0, 0);
            }
          } else {
            if (SubmitEvent == 1) {
              setSubmitEvent(0);
              getDataFunction();
            } else {
              getDataFunction();
              props.nextStep();
              window.scrollTo(0, 0);
            }
          }
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError(ERROR_EXISTS);
          setLoading(false);
        } else {
          toastError(ERROR_MESSAGE);
          setLoading(false);
        }
      });
  };

  const getDataFunction = (checkgetapi) => {
    if (paramObject.id > 0 || checkgetapi) {
      setLoading(true);
      setItemFieldshow(false);
      axios
        .get(
          `${config.itemsBaseUrl}/items/iteminfofindbyid?id=${paramObject.id}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )

        .then((res) => {
          if (res.data.ResponseCode === "SUCCESS") {
            setGlobalAttribute(res.data.ResponseData.GlobalAttributeValues);
            setAttributeName(res.data.ResponseData.Attributename);
            setAttributeValue(res.data.ResponseData.Attributevalues);
            setNewVariation(res.data.ResponseData.VariactionName);
            if (res.data?.ResponseData?.VariactionName?.length > 0) {
              setVariationCheckBox(true);
            }
            setSelectedBrand(res.data.ResponseData.Items[0].BrandId);
            setisservice(
              res.data.ResponseData.Items[0].Isservice === 1 ? true : false
            );
            setItemQuickbookId(res.data.ResponseData.Items[0].QuickbookId);
            setPrimeSupplier({
              label: "",
              value: Number(res.data.ResponseData.Items[0].SupplierId),
            });
            setQuickbookId(
              Number(res.data.ResponseData.Items[0].SupplierQuickbookId)
            );
            handleDropdowns();
            let Dropdown = "SelectAnAttribute";
            setSelectedAttributeIddrop(Dropdown);
            const mappedReceivingItems = res.data.ResponseData.ItemNumbers.map(
              (item) => {
                const mappedItem = {
                  ID: item.ID,
                  ItemNumbers: item.Itemnumber,
                };
                return mappedItem;
              }
            );
            setItem(mappedReceivingItems);
            // setIncomeQuickbookId(res.data.ResponseData.Items[0]?.QuickBookIncomeAccountID)
            // setInventoryAssestQuickbookId(res.data.ResponseData.Items[0]?.QuickBookInventoryAssetsAccountID)
            // setExpenseQuickbookId(res.data.ResponseData.Items[0]?.QuickBookExpenseAccountID)
            setSelectedtags(res.data.ResponseData.Items[0].Tagid);
            setiddata(res.data.ResponseData.Items[0].ID);
            setselectmanufacturedropdwonData(
              res.data.ResponseData.Items[0].ManufacturerId
            );

            //for Modifires
            const modifierIds = res.data.ResponseData.Modifiers?.map(
              (modifier) => modifier.ModifierId?.toString()
            );
            const newArray = modifierIds?.map((str) => parseInt(str, 10)); // array with commaseparet
            setCheck(newArray);

            let data = res.data.ResponseData?.Items[0];
            setUnitPrice(data.UnitPrice);
            setCostPrice(data.CostPrice);
            setItemNameForVariation(data.Name);
            const itemsdata = {
              ItemName: data.Name,
              BarcodeName: data.Barcodename,
              UpcName: data.Itemnumber,
              ProductId: data.ProductId,
              Description: data.Description,
              LongDescription: data.Longdescription,
              ImPOP: data.InfoPopup,
              Weight: parseFloat(data.Weight).toFixed(2),
              DimensionsLength: parseFloat(data.Length).toFixed(2),
              DimensionsWidth: parseFloat(data.Width).toFixed(2),
              DimensionsHeight: parseFloat(data.Height).toFixed(2),
            };
            setWeightUnit(data.Weightunit);
            setFormValues(itemsdata);
            setItemProductID(data.ProductId);

            let AttributesNames = res.data.ResponseData.Attributename;
            let AttributeValues = res.data.ResponseData.Attributevalues;
            const VariactionName = res.data.ResponseData.VariactionName;
            // const VariationValue = res.data.ResponseData.VariactionValues;

            const CombineObject = AttributesNames?.map((obj) => {
              const matchingValues = AttributeValues.filter(
                (valueObj) => valueObj.Attributeid === obj.ID
              );
              const value = matchingValues.map((valueObj) => {
                return { ID: valueObj.ID, Name: valueObj.Name };
              });
              return { ID: obj.ID, Name: obj.Name, Quantity: value };
            });
            const ResultObject = VariactionName.map((obj) => {
              return {
                ItemVariationId: obj.ID || "",
                VariationName: obj.Name || "",
                VariationAttributes: obj.VariationAttributes || "",
                VariationItemNumber: obj?.ItemNumber || "",
                VariationID: `${data.ID}-${obj.ID}` || "",
                SupplierId: obj?.SupplierId || "",
                VariationProductId: obj?.VariationProductId || "",
                itemvariationquickbookid: obj?.QuickbookId || "",
                unitprice: obj?.UnitPrice ? obj?.UnitPrice : 0,
                costprice: obj?.CostPrice ? obj?.CostPrice : 0,
                variationquantity: obj?.VariationQuantity
                  ? obj?.VariationQuantity
                  : 0,
              };
            });

            setItemAttribute(CombineObject);
            setItemvariations(ResultObject);

            if (res.data.ResponseData.Catagories.length > 0) {
              setCategory(res.data.ResponseData.Catagories);
            }
            if (res.data.ResponseData.Suppliers.length > 0) {
              setSupplier(res.data.ResponseData.Suppliers);
            }
            setQuantity(res.data.ResponseData.itemsserialnumber);
            handleDropdownData(res.data.ResponseData.Items[0].CategoryId);
            axios
              .get(
                `${config.itemsBaseUrl}/items/itemswiseattributeslist?ItemId=${paramObject.id}`,
                {
                  headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: token,
                  },
                }
              )
              .then((res) => {
                setVariationlist(res.data.ResponseData);
              });

            setLoading(false);
          } else if (
            res.data.ResponseCode === "ERROR" &&
            res.data.ResponseID === -1
          ) {
            toastError(ERROR_EXISTS);
            setLoading(false);
          } else {
            toastError(ERROR_MESSAGE);
            setLoading(false);
          }
        });
    } else {
      setItemFieldshow(true);
      handleDropdownData();
    }
  };

  useEffect(() => {
    getDataFunction();
  }, [deleteTableRowsFunction, valueStringFunction]);

  function handleButtonClick() {
    buttonRef.current.click();
  }
  function handleCancelButtonClick() {
    navigate("/items");
  }

  // const selectStyles = {
  //   menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  // };

  return (
    <>
      <Sidebar />
      <Loader loading={loading} />
      <div className="card card-body">
        <Formik
          {...props}
          initialValues={formValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          <div className="card-header d-flex justify-content-between align-items-center p-1 m-1">
            <p className="card-title">
              Item Information
              {/* (Fields in <span className="text-danger">*</span>
              are required) */}
            </p>
            {ItemFieldshow === false && (
              <div>
                {props.currentStep < props.totalSteps && (
                  <button
                    //   onClick={handleNext}
                    className="btn btn-sm btn-secondary btn-md nxtS"
                    type="button"
                    onClick={handleButtonClick}
                  >
                    Next
                  </button>
                )}
              </div>
            )}
          </div>
        </Formik>
        <Formik
          {...props}
          initialValues={formValues}
          // initialValues={{ ItemName: "Hello1", BarcodeName: "Hello2", UpcName: "Hello3" }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ errors, touched, handleChange }) => (
            <Form onKeyPress={(e) => e.key === "Enter" && e.preventDefault()}>
              <div className="card-body">
                {/* Item Name */}
                <div className="row">
                  <div className="col-sm-6">
                    <div className="row">
                      <label className="col-form-label col-md-4 p-lg-medium">
                        Item Name<span className="text-danger">*</span>
                      </label>
                      <div className="col-md-8">
                        <Field
                          type="text"
                          className={`form-control form-control-sm  ${
                            errors.ItemName ? "is-invalid" : ""
                          }`}
                          name="ItemName"
                          id="ItemName"
                          // onChange={handleChange}
                          onChange={(e) => {
                            handleChange(e);
                            setItemNameForVariation(e.target.value);
                            updateVariationName(e.target.value)
                          }}
                        />
                        <div className="invalid-feedback">
                          {touched.ItemName && errors.ItemName
                            ? errors.ItemName
                            : ""}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Barcode Display Name */}
                  <div className="col-sm-6">
                    <div className="row">
                      <label className="col-form-label col-md-4 p-lg-medium">
                        Barcode Display Name
                      </label>
                      <div className="col-md-8">
                        <Field
                          type="text"
                          className="form-control form-control-sm"
                          name="BarcodeName"
                          id="BarcodeName"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* UPC and product id */}
                <div className="row mt-2">
                  <div className="col-sm-6">
                    <div className="row">
                      <label className="col-form-label col-md-4 p-lg-medium">
                        UPC/EAN/ISBN
                      </label>
                      <div className="col-md-8">
                        <Field
                          type="text"
                          name="UpcName"
                          id="UpcName"
                          onChange={handleChange}
                          className="form-control form-control-sm"
                          // disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="row">
                      <label className="col-form-label col-md-4 p-lg-medium">
                        Product ID
                      </label>
                      <div className="col-md-8">
                        <Field
                          type="text"
                          id="ProductId"
                          name="ProductId"
                          onChange={(e) => {
                            handleChange(e)
                            handelProductChange(e)}}
                          className="form-control form-control-sm"
                          value={itemProductID}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Additional Item Numbers */}
                <div className="row mt-2">
                  <label className="form-label col-md-2 mt-2 p-lg-medium">
                    Additional Item Numbers
                  </label>
                  <div className="col-md-7">
                    <table
                      id="AdditionalItem"
                      name="AdditionalItem"
                      className="table table-responsive p-0"
                    >
                      <thead>
                        <tr>
                          <th className="p-regular">Item Number</th>
                          <th className="p-regular">Delete</th>
                        </tr>
                      </thead>
                      <tbody>
                        {item?.map((data, index) => {
                          const { ID, ItemNumbers } = data;
                          return (
                            <tr key={index}>
                              <td
                                style={{
                                  padding: 0,
                                  width: "80%",
                                }}
                              >
                                <input type="hidden" name="ID" value={ID} />
                                <input
                                  type="text"
                                  className="form-control form-control-sm"
                                  name="ItemNumbers"
                                  value={ItemNumbers}
                                  onChange={(event) =>
                                    handleChangeforitems(index, event)
                                  }
                                />
                              </td>
                              <td style={{ textAlign: "center" }}>
                                <i
                                  className="fa fa-trash text-red fa-2x"
                                  data-bs-toggle="tooltip"
                                  title="Delete"
                                  onClick={() =>
                                    deleteForAdditionalTableRows(index)
                                  }
                                  // disabled
                                />
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                  <div className="col-md-3 mt-2">
                    <button
                      type="button"
                      className="btn-third"
                      onClick={addItem}
                    >
                      <IoMdAddCircle /> Add UPC Number
                    </button>
                  </div>
                </div>

                {/* Category */}
                <div className="row mt-1 d-flex">
                  <label className="col-md-2 col-form-label p-lg-medium">
                    Category
                    <span className="text-danger">*</span>
                  </label>
                  <div className="col-md-7">
                    <div className="row">
                      <div className="col">
                        <Select
                          backspaceRemovesValue={false}
                          controlShouldRenderValue={true}
                          hideSelectedOptions={true}
                          isClearable={false}
                          onChange={setselectedCategory}
                          options={ParentCategoryOption}
                          placeholder=""
                          styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                          value={
                            ParentCategoryOption.find(
                              (option) =>
                                option.value === selectedCategory.value
                            ) || ""
                          }
                          id="Category"
                          name="Category"
                          className="w-100 custom-search-select"
                        />
                      </div>
                      <div className="col-md-2"></div>
                    </div>
                  </div>
                  <div className="col-md-3 ">
                    <Link
                      data-bs-toggle="modal"
                      data-backdrop="static"
                      data-keyboard="false"
                      className="btn-third"
                      onClick={() => handleShow()}
                      style={{ marginTop: "0.5rem", marginLeft: "6px" }}
                    >
                      <IoMdAddCircle /> Add New Category
                    </Link>
                  </div>
                </div>

                {/* Add Categories Model */}
                <Modal show={show} onHide={handleClose} className="modal-lg">
                  <Modal.Header>
                    <Modal.Title>
                      Add Category / Secondary Category{" "}
                    </Modal.Title>
                    <button
                      type="button"
                      className="btn-close"
                      aria-label="Close"
                      onClick={handleClose}
                    >
                      x
                    </button>
                  </Modal.Header>
                  <Formik
                    {...props}
                    initialValues={formValuesformodel}
                    validationSchema={validationSchemaformodel}
                    onSubmit={handleSubmitformodel}
                    // enableReinitialize
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                    }) => (
                      <Form
                        onKeyPress={(e) =>
                          e.key === "Enter" && e.preventDefault()
                        }
                      >
                        <Loader loading={loading} />
                        <div className="modal-body">
                          <div className="form-group row">
                            <div className="col-md-3">
                              <label className="form-label">
                                Parent Category
                              </label>
                            </div>
                            <div className="col-md-9 mb-3">
                              <Select
                                backspaceRemovesValue={false}
                                controlShouldRenderValue={true}
                                hideSelectedOptions={true}
                                isClearable={true}
                                onChange={(e) => {
                                  setselectedParentCategory(e);
                                }}
                                options={ParentCategoryOption}
                                placeholder=""
                                styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                value={selectedParentCategory}
                                id="ParentID"
                                name="ParentID"
                                className="w-100 custom-search-select "
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label className="col-form-label col-md-3 align-center">
                              Category Name
                            </label>
                            <div className="col-md-9 mt-2">
                              <Field
                                type="text"
                                name="CategoryName"
                                id="CategoryName"
                                className={` custom-search-select form-control form-control-sm ${
                                  errors.CategoryName ? "is-invalid" : ""
                                }`}
                                placeholder="Enter Category Name"
                                value={values.CategoryName}
                                onBlur={handleBlur}
                                onChange={handleChange}
                              />
                              <div className="invalid-feedback">
                                {touched.CategoryName && errors.CategoryName
                                  ? errors.CategoryName
                                  : ""}
                              </div>
                            </div>
                          </div>

                          <div className="form-group row">
                            <label className="col-form-label col-md-3 align-center">
                              Category Color
                            </label>
                            <div className="col-md-9 mt-2">
                              <Field
                                type="color"
                                name="Color"
                                className={`form-control form-control-sm form-control-color`}
                                value={values.Color}
                                onBlur={handleBlur}
                                onChange={handleChange}
                              />
                            </div>
                          </div>

                          <div className="form-group row">
                            <label className="col-form-label col-md-3 align-center">
                              Category Image
                            </label>
                            <div className="col-md-9 mt-2">
                              <FileInput
                                id="SelectImage"
                                name="SelectImage"
                                value={selectedImage}
                                accept="image/*"
                                handleChange={_handleFileChange}
                                // className="form-control form-control-sm form-control-color"
                              />
                              {ImageUrl && (
                                <img
                                  src={ImageUrl}
                                  alt="category"
                                  width="100px"
                                />
                              )}
                            </div>
                          </div>

                          <div className="col-lg-12 justify-content-right">
                            <button
                              type="submit"
                              className="btn btn-sm btn-primary btn-md me-2"
                            >
                              Submit
                            </button>

                            <button
                              className="btn btn-sm btn-dark btn-md me-1"
                              onClick={handleClose}
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </Modal>

                {/* Secondary Category */}
                <div className="row d-flex" style={{ marginTop: "-0.6rem" }}>
                  <div className="col-md-9">
                    {category?.map((data, index) => {
                      const { ID, CategoryId } = data;
                      return (
                        <div key={index} className="row d-flex mt-1">
                          <div
                            className="col-md-3"
                            style={{
                              width: "23%",
                              // marginLeft: "4px",
                              alignSelf: "center",
                            }}
                          >
                            <label className="col-form-label p-lg-medium">
                              Secondary Category
                            </label>
                          </div>
                          <div className="col d-flex">
                            <div className="row w-100">
                              <div
                                className="col-md-10 m-0 p-0"
                                style={{ width: "84%" }}
                              >
                                <Select
                                  backspaceRemovesValue={false}
                                  controlShouldRenderValue={true}
                                  hideSelectedOptions={true}
                                  isClearable={true}
                                  onChange={(event) =>
                                    handleChangeforDropdon(index, event)
                                  }
                                  options={Catagories}
                                  placeholder=""
                                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                  value={Catagories.find(
                                    (option) =>
                                      option.value ===
                                      category[index].CategoryId
                                  )}
                                  id="CategoryId"
                                  name="CategoryId"
                                  className="custom-search-select"
                                />
                              </div>
                              <div className="col text-center">
                                <i
                                  className="fa fa-trash text-red fa-2x"
                                  data-bs-toggle="tooltip"
                                  title="Delete"
                                  onClick={() => deleteSecondory(index)}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  <div className="col-md-3 " style={{ marginTop: "0.4rem" }}>
                    <button
                      type="button"
                      className="btn-third"
                      onClick={addCategory}
                      style={{ marginTop: "0.5rem" }}
                    >
                      <IoMdAddCircle /> Add Secondary Category
                    </button>
                  </div>
                </div>

                {/* Supplier */}
                <div className="row d-flex">
                  <label className="col-md-2 col-form-label p-lg-medium">
                    Supplier
                    {/* <span className="text-danger">*</span> */}
                  </label>
                  <div className="col-md-7">
                    <div className="row">
                      <div className="col">
                        <Select
                          backspaceRemovesValue={false}
                          controlShouldRenderValue={true}
                          hideSelectedOptions={true}
                          isClearable={true}
                          options={Supplierlist}
                          value={Supplierlist?.find(
                            (el) => el.value === primeSupplier.value
                          )}
                          placeholder=""
                          styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                          id="SupplierId"
                          name="SupplierId"
                          onChange={(event) => handleChangePrimeSupplier(event)}
                          className="custom-search-select"
                        />
                      </div>
                      <div className="col-md-2"></div>
                    </div>
                  </div>
                  <div className="col-md-3"></div>
                </div>

                {/* Secondary Supplier */}
                <div className="row d-flex" style={{ marginTop: "-0.3rem" }}>
                  <div className="col-md-9">
                    {supplier?.map((data, index) => {
                      return (
                        <div key={index} className="row d-flex">
                          <div
                            className="col-md-3"
                            style={{
                              width: "23%",
                              // marginLeft: "4px",
                              alignSelf: "center",
                            }}
                          >
                            <label className="col-form-label p-lg-medium">
                              Secondary Supplier
                            </label>
                          </div>
                          <div className="col d-flex">
                            <div className="row w-100">
                              <div
                                className="col-md-10 m-0 p-0"
                                style={{ width: "84%" }}
                              >
                                <Select
                                  backspaceRemovesValue={false}
                                  controlShouldRenderValue={true}
                                  // hideSelectedOptions={true}
                                  isClearable={true}
                                  onChange={(event) =>
                                    handleChangeforDropdonsuppliers(
                                      index,
                                      event
                                    )
                                  }
                                  options={Supplierlist}
                                  placeholder=""
                                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                  value={
                                    Supplierlist
                                      ? Supplierlist.find(
                                          (option) =>
                                            option.value ==
                                            supplier[index]?.SupplierId
                                        )
                                      : []
                                  }
                                  id="SupplierId"
                                  name="SupplierId"
                                  className="custom-search-select"
                                />
                              </div>
                              <div className="col text-center">
                                <i
                                  className="fa fa-trash text-red fa-2x"
                                  data-bs-toggle="tooltip"
                                  title="Delete"
                                  onClick={() => deleteSuppliers(index)}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  <div className="col-md-3" style={{ marginTop: "0.5rem" }}>
                    <button
                      type="button"
                      className="btn-third"
                      onClick={addSupplier}
                    >
                      <IoMdAddCircle /> Add Supplier
                    </button>
                  </div>
                </div>

                {/* Brands */}
                <div className="row d-flex">
                  <label className="col-md-2 col-form-label p-lg-medium">
                    Brands
                  </label>
                  <div className="col-md-7">
                    <div className="row">
                      <div className="col">
                        <Select
                          backspaceRemovesValue={false}
                          controlShouldRenderValue={true}
                          hideSelectedOptions={true}
                          isClearable={true}
                          onChange={(e) => setSelectedBrand(e.value)}
                          options={Brandsdropdown}
                          placeholder=""
                          styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                          value={Brandsdropdown.find(
                            (option) => option.value === selectedBrand
                          )}
                          id="Category"
                          name="Category"
                          className="w-100 custom-search-select"
                        />
                      </div>
                      <div className="col-md-2"></div>
                    </div>
                  </div>
                  <div className="col-md-3" style={{ marginTop: "0.5rem" }}>
                    {checkUserPermission(PERMISSION_ADD) ? (
                      <Link
                        to="#"
                        data-bs-toggle="modal"
                        data-bs-target="#ManageDataModal"
                        data-backdrop="static"
                        data-keyboard="false"
                        className="btn-third ml-1"
                        onClick={() => handleShowAddBrand()}
                      >
                        <IoMdAddCircle /> Add Brand
                      </Link>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                {/* Brands Modal */}
                <Modal
                  show={showAddBrand}
                  onHide={handleCloseAddBrand}
                  className="modal-md"
                >
                  <Modal.Header>
                    <Modal.Title>Manage Brands </Modal.Title>
                    <button
                      type="button"
                      className="btn-close"
                      aria-label="Close"
                      onClick={() => {
                        handleCloseAddBrand();
                        setError({ ...error, brandError: "" });
                      }}
                    >
                      x
                    </button>
                  </Modal.Header>
                  <Formik {...props}>
                    {({ errors, touched, handleBlur }) => (
                      <>
                        <Loader loading={loading} />
                        <div className="modal-body">
                          <div className="form-group row">
                            <label className="col-form-label col-md-3 align-center ">
                              Brand Name
                            </label>
                            <div className="col-md-9 mt-2">
                              <Field
                                type="text"
                                className="form-control form-control-sm"
                                name="CategoryName"
                                id="CategoryName"
                                placeholder="Enter Brand Name"
                                onBlur={handleBlur}
                                onChange={(e) => {
                                  setAddBrand(e.target.value);
                                  e.target.value &&
                                    setError({ ...error, brandError: "" });
                                }}
                              />
                              {error?.brandError && (
                                <div className="error-message">
                                  {error?.brandError}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-lg-12 justify-content-right">
                            <button
                              disabled={loading == true}
                              type="button"
                              className="btn btn-sm btn-primary btn-md me-2"
                              onClick={handleAddBrand}
                            >
                              Submit
                            </button>

                            <button
                              className="btn btn-sm btn-dark btn-md me-1"
                              onClick={() => {
                                handleCloseAddBrand();
                                setError({ ...error, brandError: "" });
                              }}
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </>
                      // </Form>
                    )}
                  </Formik>
                </Modal>

                {/* Tags */}
                <div className="row d-flex">
                  <label className="col-md-2 col-form-label p-lg-medium">
                    Tags
                  </label>
                  <div className="col-md-7">
                    <div className="row">
                      <div className="col">
                        <Select
                          backspaceRemovesValue={false}
                          controlShouldRenderValue={true}
                          hideSelectedOptions={true}
                          isClearable={true}
                          isMulti={true}
                          onChange={handleSelectedtags}
                          options={TagsList}
                          placeholder=""
                          styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                          value={TagsList?.filter((obj) =>
                            selectedtags?.includes(obj.value)
                          )}
                          id="Tags"
                          name="Tags"
                          className="w-100 custom-search-select"
                        />
                      </div>
                      <div className="col-md-2"></div>
                    </div>
                  </div>
                  <div className="col-md-3" style={{ marginTop: "0.5rem" }}>
                    {checkUserPermission(PERMISSION_ADD) ? (
                      <button
                        type="button"
                        className="btn-third"
                        data-bs-toggle="modal"
                        data-bs-target="#ManageDataModal"
                        onClick={() => handeltagmodelShow()}
                        // disabled
                      >
                        <IoMdAddCircle /> Add Tags
                      </button>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                {/* Tag Modal */}
                <Modal
                  show={showtag}
                  onHide={handleClose}
                  className="modal-md"
                  id="ManageDataModal"
                >
                  <Modal.Header>
                    <Modal.Title>Add Tags</Modal.Title>
                    <button
                      type="button"
                      className="btn-close"
                      aria-label="Close"
                      onClick={() => {
                        handeltagmodelClose();
                        setError({ ...error, tagError: "" });
                      }}
                    >
                      x
                    </button>
                  </Modal.Header>
                  <Formik
                    {...props}
                    initialValues={formValuesfortagmodel}
                    onSubmit={handleSubmitformodeltags}
                    // enableReinitialize
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                    }) => (
                      <Form
                        onKeyPress={(e) =>
                          e.key === "Enter" && e.preventDefault()
                        }
                      >
                        <Loader loading={loading} />
                        <div className="modal-body">
                          <div className="form-group row">
                            <label className="col-form-label col-md-3 align-center">
                              Tags
                            </label>
                            <div className="col-md-9 mt-2">
                              <Field
                                type="text"
                                name="Tags"
                                id="Tags"
                                className="form-control form-control-sm"
                                placeholder="Enter Tag Name"
                                onBlur={handleBlur}
                                onChange={handleChange}
                              />
                              {error?.tagError && (
                                <div className="error-message">
                                  {error?.tagError}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-lg-12 justify-content-right">
                            <button
                              type="submit"
                              className="btn btn-sm btn-primary btn-md me-2"
                            >
                              Submit
                            </button>
                            <button
                              className="btn btn-sm btn-dark btn-md me-1"
                              onClick={() => {
                                handeltagmodelClose();
                                setError({ ...error, tagError: "" });
                              }}
                              type="button"
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </Modal>

                {/* Manufacturers */}
                <div className="row d-flex">
                  <label className="col-md-2 col-form-label p-lg-medium">
                    Manufacturers
                  </label>
                  <div className="col-md-7">
                    <div className="row">
                      <div className="col react-select-height">
                        <Select
                          backspaceRemovesValue={false}
                          controlShouldRenderValue={true}
                          hideSelectedOptions={true}
                          isClearable={true}
                          onChange={(e) =>
                            setselectmanufacturedropdwonData(e.value)
                          }
                          options={Manufacturerdropdown}
                          placeholder=""
                          styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                          value={
                            Manufacturerdropdown?.find(
                              (option) =>
                                option?.value === selectmanufacturedropdwonData
                            ) || ""
                          }
                          id="Category"
                          name="Category"
                          className="w-100 custom-search-select"
                          menuPortalTarget={document.body}
                        />
                      </div>
                      <div className="col-md-2"></div>
                    </div>
                  </div>
                  <div className="col-md-3" style={{ marginTop: "0.5rem" }}>
                    {checkUserPermission(PERMISSION_ADD) ? (
                      <button
                        type="button"
                        className="btn-third"
                        data-bs-toggle="modal"
                        data-bs-target="#ManageDataModalManufacture"
                        onClick={() => handleManufactureShow()}

                        // disabled
                      >
                        <IoMdAddCircle /> Add Manufacturer
                      </button>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                <div className="row d-flex">
                  <label className="col-md-2 col-form-label p-lg-medium">
                    Is Service
                  </label>
                  <div className="col-md-7">
                    <div className="row">
                      <div className="col react-select-height">
                        <input
                          type="checkbox"
                          id="myCheckbox"
                          name="myCheckbox"
                          value="true"
                          onChange={(e) =>
                            handelisserviceCheckFun(e.target.checked)
                          }
                          checked={isservice}
                          style={{
                            height: "20px",
                            width: "20px",
                          }}
                          disabled={iddata > 0}
                        />
                      </div>
                      <div className="col-md-2"></div>
                    </div>
                  </div>
                </div>

                {/* Manufacturers Modal */}
                <Modal
                  show={showManufacture}
                  onHide={handleManufactureClose}
                  className="modal-md"
                  id="ManageDataModalManufacture"
                >
                  <Modal.Header>
                    <Modal.Title>Add Manufacture</Modal.Title>
                    <button
                      type="button"
                      className="btn-close"
                      aria-label="Close"
                      onClick={() => {
                        handleManufactureClose();
                        setError({ ...error, manufactureError: "" });
                      }}
                    >
                      x
                    </button>
                  </Modal.Header>
                  <Formik
                    {...props}
                    initialValues={formValuesformenufacturemodel}
                    onSubmit={handleSubmitformodelManufacture}
                    // enableReinitialize
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                    }) => (
                      <Form
                        onKeyPress={(e) =>
                          e.key === "Enter" && e.preventDefault()
                        }
                      >
                        <Loader loading={loading} />
                        <div className="modal-body">
                          <div className="form-group row">
                            <label className="col-form-label col-md-3 align-center">
                              Manufacture
                            </label>
                            <div className="col-md-9 mt-2">
                              <Field
                                type="text"
                                name="Manufacture"
                                id="Manufacture"
                                placeholder="Enter Manufacture Name"
                                className="form-control form-control-sm"
                                onBlur={(e) => {
                                  handleBlur(e);
                                  !e &&
                                    setError({
                                      ...error,
                                      manufactureError: "",
                                    });
                                }}
                                onChange={handleChange}
                              />
                              {error?.manufactureError && (
                                <div className="error-message">
                                  {error?.manufactureError}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-lg-12 justify-content-right">
                            <button
                              type="submit"
                              className="btn btn-sm btn-primary btn-md me-2"
                            >
                              Submit
                            </button>
                            <button
                              className="btn btn-sm btn-dark btn-md me-1"
                              onClick={() => {
                                handleManufactureClose();
                                setError({ ...error, manufactureError: "" });
                              }}
                              type="button"
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </Modal>

                {/* ------------------------------------Item details------------------------------ */}
                <div className="card">
                  <h5 className="card-title">Item Details</h5>
                  <div>
                    {/* Weight and Dimension */}
                    <div className="row mt-0 d-flex justify-content-between align-item-center col-11">
                      <div className="col" style={{ marginTop: "-1rem" }}>
                        <div className="row d-flex">
                          <div className="col d-flex">
                            <label className="form-label col-md-3  col-form-label p-lg-medium">
                              Weight
                            </label>
                            <div className="col-md-6">
                              <Field
                                type="number"
                                className="form-control form-control-sm"
                                id="Weight"
                                name="Weight"
                                onChange={handleChange}
                                // disabled
                              />
                            </div>
                          </div>
                          <div className="col d-flex">
                            <label className="form-label col-md-5 col-form-label p-lg-medium">
                              Weight Unit
                            </label>
                            <div
                              className="col-md-6"
                              style={{ marginTop: "-0.4rem" }}
                            >
                              <select
                                className="form-control form-control-sm"
                                id="WeightUnit"
                                name="WeightUnit"
                                onChange={(e) => setWeightUnit(e.target.value)}
                                value={WeightUnit}
                              >
                                <option value="0">None</option>
                                <option value="1">lb</option>
                                <option value="2">Oz</option>
                                <option value="3">kg</option>
                                <option value="4">g</option>
                                <option value="5">l</option>
                                <option value="6">ml</option>
                                <option value="7">cf</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="col d-flex justify-content-between align-item-center"
                        style={{ marginTop: "-1rem" }}
                      >
                        <label className="form-label col-md-3 col-form-label p-lg-medium">
                          Dimensions
                        </label>
                        <div className="col-md-3">
                          <Field
                            type="number"
                            className="form-control form-control-sm"
                            placeholder="Length"
                            id="DimensionsLength"
                            name="DimensionsLength"
                            onChange={handleChange}
                            // disabled
                          />
                        </div>
                        <div className="col-md-3 ml-2">
                          <Field
                            type="number"
                            className="form-control form-control-sm"
                            placeholder="Width"
                            id="DimensionsWidth"
                            name="DimensionsWidth"
                            onChange={handleChange}
                            // disabled
                          />
                        </div>
                        <div className="col-md-3 ml-2">
                          <Field
                            type="number"
                            className="form-control form-control-sm"
                            placeholder="Height"
                            id="DimensionsHeight"
                            name="DimensionsHeight"
                            onChange={handleChange}
                            // disabled
                          />
                        </div>
                      </div>
                    </div>

                    {/* Descriptions */}
                    <div className="row mt-0 d-flex">
                      <div
                        className="col-md-6"
                        style={{ marginTop: "-0.7rem" }}
                      >
                        <Field
                          name="Description"
                          id="Description"
                          cols="17"
                          rows="5"
                          className="form-control form-control-sm text-area"
                          as="textarea"
                          onChange={handleChange}
                          placeHolder={"Description"}
                        />
                      </div>
                      {/* <div className="col-md-4">
                        <Field
                          name="LongDescription"
                          id="LongDescription"
                          cols="17"
                          rows="5"
                          className="form-control text-area"
                          as="textarea"
                          onChange={handleChange}
                          placeHolder={"Long Description"}

                        />
                      </div> */}
                      <div
                        className="col-md-6"
                        style={{ marginTop: "-0.7rem" }}
                      >
                        <Field
                          name="ImPOP"
                          id="ImPOP"
                          cols="17"
                          rows="5"
                          className="form-control form-control-sm text-area"
                          as="textarea"
                          onChange={handleChange}
                          placeHolder="Information Popup When Adding To Sale"
                        />
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-md-12">
                        {/* <Field
                          name="LongDescription"
                          id="LongDescription"
                          cols="17"
                          rows="5"
                          className="form-control text-area"
                          as="textarea"
                          onChange={handleChange}
                          placeHolder={"Long Description"}
                        /> */}
                        <label className="form-label col-md-2 col-form-label p-lg-medium">
                          Long Description
                        </label>

                        <Field name="LongDescription" id="LongDescription">
                          {({ field }) => (
                            <ReactQuill
                              value={field.value}
                              theme="snow"
                              placeholder="Long Description"
                              style={{ height: "150px" }}
                              onChange={field.onChange("LongDescription")}
                            />
                          )}
                        </Field>

                        {/* <ReactQuill theme="snow" name="LongDescription" id="LongDescription" placeholder="Long Description" style={{height: "200px"}} onChange={handleChange} />; */}
                      </div>
                    </div>
                  </div>
                  <div className="row mt-8">
                    <div className="col-md-12">
                      <label className="form-label col-form-label p-lg-medium">
                        <input
                          className="mr-2"
                          type="checkbox"
                          onChange={(e) =>
                            handelVariationCheckFun(e.target.checked)
                          }
                          checked={variationCheckBox}
                        />
                        <strong>Want to Create Variation</strong>
                      </label>

                      {/* <ReactQuill theme="snow" name="LongDescription" id="LongDescription" placeholder="Long Description" style={{height: "200px"}} onChange={handleChange} />; */}
                    </div>
                  </div>
                </div>

                {/* ------------------------------------Item Attributes------------------------------ */}
                {/* Quantity Units */}

                {ItemFieldshow === false && (
                  <>
                    {variationCheckBox && (
                      <>
                        <div className="card-body">
                          <h5 className="card-title m-1">Variations</h5>
                          <div className="container-fluid mt-0">
                            <div className="row d-flex">
                              <div className="col-2">
                                <label className="col-form-label p-lg-medium">
                                  Item Attributes
                                </label>
                              </div>
                              {/* -----------working------------ */}
                              <div className="col-7">
                                <div className="input-group">
                                  <select
                                    id="selected"
                                    ref={selectRef}
                                    className="form-control form-control-sm"
                                    onChange={handledrop}
                                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                  >
                                    <option
                                      value="SelectAnAttribute"
                                      values2={1}
                                    >
                                      Select An Attribute
                                    </option>
                                    <option
                                      value="NewCustomAttribute"
                                      values2={2}
                                    >
                                      New Custom Attribute
                                    </option>
                                    {options.map((option, index) => (
                                      <option
                                        key={index}
                                        value={option.ID}
                                        label={option.Name}
                                        values2={option.AttributevalueId}
                                      >
                                        {option.Name}
                                      </option>
                                    ))}
                                  </select>
                                  {Attributedrop === true ? (
                                    <button
                                      type="button"
                                      data-bs-toggle="modal"
                                      data-backdrop="static"
                                      data-keyboard="false"
                                      className="btn btn-secondary "
                                      // style={{ height: "2.5rem" }}
                                      onClick={() => handeltagsmodelShow()}
                                    >
                                      <span>Add</span>
                                    </button>
                                  ) : (
                                    <button
                                      type="button"
                                      className={`btn-sm ${
                                        selectRef.current?.value ===
                                        "SelectAnAttribute"
                                          ? "desablecolour"
                                          : "btn-primary"
                                      }`}
                                      onClick={handleAttributsAdd}
                                      disabled={
                                        selectRef.current?.value ===
                                        "SelectAnAttribute"
                                      }
                                    >
                                      <span className="font-white">
                                        Add Attribute
                                      </span>
                                    </button>
                                  )}
                                </div>
                              </div>
                              <div className="col-3 text-end mt-3">
                                <Link
                                  to="/attributes"
                                  state={paramObject.id}
                                  className=" btn-third text-right"
                                >
                                  <IoMdAddCircle /> Manage Global Attributes
                                </Link>
                              </div>
                            </div>
                            <div>
                              <table className="table pb-2">
                                <thead>
                                  {itemattribute.length > 0 ? (
                                    <tr>
                                      <th className="p-regular">Name</th>
                                      <th className="p-regular">Values</th>
                                      <th className="p-regular">Delete</th>
                                      <th></th>
                                    </tr>
                                  ) : (
                                    ""
                                  )}
                                </thead>
                                <tbody>
                                  <AttributesTableRows
                                    globalAttribute={globalAttribute}
                                    attributeName={attributeName}
                                    attributeValue={attributeValue}
                                    rowsData={itemattribute}
                                    setRowsData={setItemAttribute}
                                    deleteTableRows={deleteTableRows}
                                    handleChange={
                                      handleChangeAttributesTableRow
                                    }
                                    itemNameForVariation={itemNameForVariation}
                                    // callback={handleAttributesValues}
                                  />
                                </tbody>
                              </table>
                            </div>

                            <div className="row mt-1">
                              <h5 className="card-title ">Item Variations</h5>
                              <div className="mb-3 ">
                                <table className="table">
                                  <thead>
                                    <tr>
                                      <th width="10%" className="p-regular">
                                        Product Id
                                      </th>
                                      <th width="20%" className="p-regular">
                                        Name
                                      </th>
                                      <th width="25%" className="p-regular">
                                        Attributes
                                      </th>
                                      <th width="20%" className="p-regular">
                                        Item Number
                                        <p
                                          style={{ fontSize: "10px  " }}
                                          className="text-danger"
                                        >
                                          * After Input Please Press Enter
                                        </p>
                                      </th>
                                      <th width="1%" className="p-regular">
                                        Variation ID
                                      </th>
                                      <th width="20%" className="p-regular">
                                        Supplier
                                      </th>
                                      <th width="1%">Delete</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <ItemVariactionTableRows
                                      newVariation={newVariation}
                                      rowsData={Itemvariations}
                                      DropdownOptions={Variationlist}
                                      deleteTableRows={
                                        deleteTableRowsVariaction
                                      }
                                      handleChange={handleChangeVariation}
                                    />
                                  </tbody>
                                </table>
                              </div>

                              <div
                                className="card-header d-flex justify-content-end align-items-baseline"
                                // style={{ marginTop: "-1.5rem" }}
                              >
                                <div>
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-secondary ml-3"
                                    onClick={addNewVariaction}
                                  >
                                    <IoMdAddCircle /> Add
                                  </button>
                                </div>
                                {itemattribute.length > 0 && (
                                  <div>
                                    <button
                                      type="button"
                                      className="btn btn-primary ml-3"
                                      onClick={handleautovariaction}
                                      disabled={
                                        keepAttributesForNewVariation.length ===
                                        0
                                      }
                                    >
                                      Auto Generate
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* // Add Attribut Name */}
                        <Modal
                          show={Attributemodel}
                          onHide={handeltagsmodelClose}
                          className="modal-lg"
                          backdrop="static"
                        >
                          <Modal.Header>
                            <Modal.Title>Add Attribute</Modal.Title>
                            <button
                              type="button"
                              className="btn-close"
                              aria-label="Close"
                              onClick={handeltagsmodelClose}
                            >
                              x
                            </button>
                          </Modal.Header>

                          <div className="modal-body">
                            <div className="form-group">
                              <Field
                                type="text"
                                name="Name1"
                                id="Name1"
                                // className="form-control"
                                placeholder="Enter Attribute Name"
                                onChange={(e) =>
                                  setItemAttributes(e.target.value)
                                }
                                // onKeyDown={handleKeyDown}
                              />
                              {nameError && (
                                <div className="error-message">{nameError}</div>
                              )}
                            </div>
                            <div
                              className="mb-3"
                              // className="form-group"
                            >
                              <Field
                               type="text"
                                  name="Name2"
                                id="Name2"
                                className="form-control"
                                onChange={handleAttributeChange}
                                placeHolder="Add New Attribute Values"
                                // placeHolder="Add New Attribute Value"
                              />
                              {attributeError && (
                                <div className="error-message">
                                  {attributeError}
                                </div>
                              )}
                            </div>
                            <div className="col-lg-12 justify-content-right">
                              <button
                                className="btn btn-primary btn-md me-2"
                                onClick={handleChangeforattribute}
                              >
                                Submit
                              </button>
                              <button
                                className="btn btn-dark btn-md me-1"
                                onClick={handeltagsmodelClose}
                              >
                                Close
                              </button>
                            </div>
                          </div>
                        </Modal>
                      </>
                    )}

                    <div className="text-center" style={{ marginTop: "-1rem" }}>
                      {props.currentStep > 1 && (
                        <button
                          onClick={handleBack}
                          className="btn btn-primary me-3"
                        >
                          Back
                        </button>
                      )}

                      {props.currentStep < props.totalSteps && (
                        <button
                          type="submit"
                          // onClick={handleNext}
                          className="btn btn-sm btn-secondary me-3"
                          ref={buttonRef}
                        >
                          Next
                        </button>
                      )}
                      <button
                        onClick={handleSubmitForm}
                        className="btn btn-sm btn-primary btn-md me-3"
                        id="btn_submit"
                        type="submit"
                        disabled={loading}
                      >
                        Save
                      </button>
                      <Link
                        to="/items"
                        className="btn btn-sm btn-secondary btn-md"
                      >
                        Cancel
                      </Link>
                    </div>
                  </>
                )}

                {/* Submit Button */}
                {ItemFieldshow === true && (
                  <div className="row">
                    <div className="col-lg-12 mt-5">
                      <button
                        type="submit"
                        className="btn btn-sm btn-primary btn-md me-2"
                      >
                        Next
                      </button>
                      <Link
                        to="/items"
                        className="btn btn-sm btn-secondary btn-md me-1"
                      >
                        Cancel
                      </Link>
                    </div>
                  </div>
                )}
              </div>
            </Form>
          )}
        </Formik>

        <ActionButtons {...props} />
      </div>
    </>
  );
};

export default memo(ItemInfo);
